import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
const mixin = {
  mixins: [validationMixin],
  validations: {
    activeFieldExpression: {
      value: {
        ja: { required },
      },
    },
  },
  computed: {
    activeFieldExpressionErrors() {
      const errors = [];
      if (!this.$v.activeFieldExpression.value.ja.$dirty) return errors;
      !this.$v.activeFieldExpression.value.ja.required &&
        errors.push("日本語を入力してください。");
      return errors;
    },

  },
};

export default mixin;
